import React, {useContext, useEffect, useState} from 'react';
import {Button, Card, Dimmer, Label, Loader, Menu} from 'semantic-ui-react'
import {fetchCourseSections} from "../../../../../redux/actions";
import {Context} from './index'
import {SectionForm} from "./SectionForm";

const Section = ({section}) => {
    const ctx = useContext(Context);
    return (
        <Menu.Item active={section.id === ctx.section_id} onClick={() => ctx.setSectionId(section.id)}>
            {section.title}
            <Label color='red'>{section.child_count || 0}</Label>
        </Menu.Item>
    )
}

export const Sections = () => {
    const ctx = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [sections, setSections] = useState([]);
    const [showForm, setShowForm] = useState(false)

    const course_id = ctx.course_id;

    async function getSections() {
        setLoading(true);
        setShowForm(false);
        try {
            // get data
            const res = await fetchCourseSections({course_id, parent_id: 0});
            // set data
            setSections(res.data);
        } catch (e) {

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        getSections();

    }, [course_id])


    return (
        <Card fluid>
            <SectionForm
                show={showForm}
                item={{course_id}}
                onCancel={() => setShowForm(false)}
                onSuccess={getSections}
            />
            <Dimmer active={loading}>
                <Loader/>
            </Dimmer>
            <Card.Content>
                <Card.Header>Módulos ({sections.length})</Card.Header>
            </Card.Content>
            <Card.Content>
                <Menu fluid secondary vertical>
                    {sections.map((section) => {
                        return <Section
                            key={`section-${section.id}`}
                            section={section}
                        />
                    })}
                    {
                        !loading && <Menu.Item>
                            <Button primary fluid onClick={() => setShowForm(true)}>Criar Módulo</Button>
                        </Menu.Item>
                    }
                </Menu>
            </Card.Content>
        </Card>
    )
}